import { memo } from 'react';

import EditIconSVG from '@/assets/edit-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IEditIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={EditIconSVG} {...props} />;

export const EditIcon = memo(IEditIcon) as typeof IEditIcon;
